"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("@flowio/events");
var loadGoogleAnalyticsGtag_1 = __importDefault(require("./loadGoogleAnalyticsGtag"));
var find_1 = __importDefault(require("lodash/find"));
var get_1 = __importDefault(require("lodash/get"));
var types_1 = require("../types");
var utilities_1 = require("../utilities");
var FLOW_TRACKER = 'flow-gtag';
var GoogleAnalyticsGtag = /** @class */ (function () {
    function GoogleAnalyticsGtag(options) {
        var defaultOpts = {
            useBaseCurrency: true,
            trackers: [],
        };
        var opts = __assign(__assign({}, defaultOpts), options);
        this.useBaseCurrency = opts.useBaseCurrency;
        this.customAttributes = opts.customAttributes;
        this.trackers = opts.trackers;
        var events = new events_1.ChannelEventEmitter();
        events.trigger('pixelGtagReady');
    }
    GoogleAnalyticsGtag.test = function (global) {
        if (global === void 0) { global = window; }
        return (typeof global.gtag === 'function');
    };
    GoogleAnalyticsGtag.configureTrackers = function (trackers) {
        if (!GoogleAnalyticsGtag.test()) {
            return;
        }
        trackers.forEach(function (tracker) {
            if (tracker.name === FLOW_TRACKER) {
                gtag('config', tracker.tracker_id, {
                    custom_map: {
                        dimension1: 'organization',
                        dimension2: 'experience_key',
                        dimension3: 'experiment_key',
                        dimension4: 'experiment_variant_key',
                    },
                });
            }
            else {
                gtag('config', tracker.tracker_id);
            }
        });
    };
    GoogleAnalyticsGtag.install = function (configuration) {
        var trackers = configuration.trackers;
        // Bail to avoid polluting global scope
        if (!trackers.length) {
            return;
        }
        // Bail if gtag is already loaded in the global scope.
        if (GoogleAnalyticsGtag.test()) {
            GoogleAnalyticsGtag.configureTrackers(trackers);
            return;
        }
        // use flow tracker if there is no default provided
        var defaultTracker = trackers.find(function (tracker) {
            return tracker.name == null;
        }) || trackers.find(function (tracker) { return tracker.name === FLOW_TRACKER; });
        // Bail if there isn't a default tracker to be used for loading the
        // global site tag library.
        if (defaultTracker == null) {
            return;
        }
        loadGoogleAnalyticsGtag_1.default(defaultTracker.tracker_id);
        GoogleAnalyticsGtag.configureTrackers(trackers);
    };
    GoogleAnalyticsGtag.prototype.fireEvent = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var gtag = window.gtag;
        if (typeof gtag === 'function') {
            gtag.apply(void 0, args);
        }
    };
    GoogleAnalyticsGtag.prototype.buildProductObjectArray = function (order) {
        var _this = this;
        var itemsArray = order.items.map(function (item) {
            var prices = get_1.default(item, 'local.prices', []);
            var itemPrice = find_1.default(prices, function (price) { return price.key === 'localized_item_price'; });
            var itemPriceAmount = _this.useBaseCurrency ? itemPrice.base.amount : itemPrice.amount;
            return {
                id: item.number,
                name: item.name,
                variant: '',
                price: itemPriceAmount,
                quantity: item.quantity,
            };
        });
        return itemsArray;
    };
    GoogleAnalyticsGtag.prototype.fireAddToCart = function (item) {
        var itemCurrency = item.currency;
        var itemPrice = item.price;
        if (this.useBaseCurrency && item.base_price != null && item.base_currency != null) {
            itemCurrency = item.base_currency;
            itemPrice = item.base_price;
        }
        var data = {
            value: item.quantity * itemPrice,
            currency: itemCurrency,
            items: [
                {
                    id: item.id,
                    name: item.name,
                    variant: '',
                    price: itemPrice,
                    quantity: item.quantity,
                },
            ],
        };
        this.fireEvent('event', 'add_to_cart', data);
    };
    GoogleAnalyticsGtag.prototype.fireBeginCheckoutStep = function (order, organization, experiment) {
        var itemsArray = this.buildProductObjectArray(order);
        var eventObject = {
            organization: organization,
            experiment_key: utilities_1.getExperimentKey(experiment),
            experiment_variant_key: utilities_1.getExperimentVariantKey(experiment),
            experience_key: order.experience && order.experience.key,
            value: this.useBaseCurrency ? order.total.base.amount : order.total.amount,
            currency: this.useBaseCurrency ? order.total.base.currency : order.total.currency,
            items: itemsArray,
            coupon_code: utilities_1.getOrderDiscountCode(order),
        };
        this.fireEvent('event', 'begin_checkout', eventObject);
    };
    GoogleAnalyticsGtag.prototype.fireShippingOptionChangedEvent = function (order) {
        var deliveryOptions = utilities_1.getSelectedDeliveryOptions(order);
        var serviceId = deliveryOptions.length > 0 ? deliveryOptions[0].service.id : undefined;
        this.fireEvent('event', 'set_checkout_option', {
            checkout_step: 2,
            checkout_option: serviceId,
        });
    };
    GoogleAnalyticsGtag.prototype.firePaymentOptionChangedEvent = function (payment) {
        this.fireEvent('event', 'set_checkout_option', {
            checkout_step: 3,
            checkout_option: payment,
        });
    };
    GoogleAnalyticsGtag.prototype.fireCheckoutProgressStep = function (order, step, defaultPayment) {
        var itemsArray = this.buildProductObjectArray(order);
        var checkoutOption;
        if (step === 2) {
            var deliveryOptions = utilities_1.getSelectedDeliveryOptions(order);
            checkoutOption = deliveryOptions.length > 0 ? deliveryOptions[0].service.id : undefined;
        }
        else if (step === 3) {
            checkoutOption = defaultPayment;
        }
        var eventObject = {
            checkout_step: step,
            value: this.useBaseCurrency ? order.total.base.amount : order.total.amount,
            currency: this.useBaseCurrency ? order.total.base.currency : order.total.currency,
            items: itemsArray,
            coupon_code: utilities_1.getOrderDiscountCode(order),
            checkout_option: checkoutOption,
        };
        this.fireEvent('event', 'checkout_progress', eventObject);
    };
    GoogleAnalyticsGtag.prototype.firePurchase = function (order) {
        var itemsArray = this.buildProductObjectArray(order);
        var shipping = order.prices.find(function (price) { return price.key === 'shipping'; });
        var shippingAmount = 0;
        if (shipping) {
            shippingAmount = this.useBaseCurrency ? shipping.base.amount : shipping.amount;
        }
        var vat = order.prices.find(function (price) { return price.key === 'vat'; });
        var vatAmount = 0;
        if (vat) {
            vatAmount = this.useBaseCurrency ? vat.base.amount : vat.amount;
        }
        this.fireEvent('event', 'purchase', {
            transaction_id: order.number,
            affiliation: 'Flow',
            value: this.useBaseCurrency ? order.total.base.amount : order.total.amount,
            currency: this.useBaseCurrency ? order.total.base.currency : order.total.currency,
            tax: vatAmount,
            shipping: shippingAmount,
            items: itemsArray,
        });
    };
    GoogleAnalyticsGtag.prototype.firePageView = function (value) {
        var trackers = this.trackers;
        var gtag = window.gtag;
        trackers.forEach(function (tracker) {
            if (typeof gtag === 'function') {
                gtag('config', tracker.tracker_id, {
                    page_title: value.title,
                    page_path: value.location,
                });
            }
        });
    };
    /**
     * Update this pixel to report metrics to the specified trackers.
     */
    GoogleAnalyticsGtag.prototype.addTrackers = function (trackers) {
        GoogleAnalyticsGtag.configureTrackers(trackers);
    };
    GoogleAnalyticsGtag.prototype.event = function (event) {
        switch (event.type) {
            case types_1.PixelEventType.PageView:
                this.firePageView(event.data.value);
                break;
            case types_1.PixelEventType.AddToCart:
                this.fireAddToCart(event.data.item);
                break;
            case types_1.PixelEventType.CheckoutInit:
                this.fireBeginCheckoutStep(event.data.order, event.data.organization, event.data.experiment);
                break;
            case types_1.PixelEventType.CheckoutCustomerInfo:
                this.fireCheckoutProgressStep(event.data.order, 1);
                break;
            case types_1.PixelEventType.CheckoutShipping:
                this.fireCheckoutProgressStep(event.data.order, 2);
                break;
            case types_1.PixelEventType.CheckoutPayment:
                this.fireCheckoutProgressStep(event.data.order, 3, event.data.defaultPayment);
                break;
            case types_1.PixelEventType.CheckoutConfirmation:
                this.fireCheckoutProgressStep(event.data.order, 4);
                break;
            case types_1.PixelEventType.CheckoutPaymentOptionChanged:
                this.firePaymentOptionChangedEvent(event.data.payment);
                break;
            case types_1.PixelEventType.CheckoutShippingOptionChanged:
                this.fireShippingOptionChangedEvent(event.data.order);
                break;
            case types_1.PixelEventType.Purchase:
            case types_1.PixelEventType.Transaction:
                this.firePurchase(event.data.order);
                break;
            case types_1.PixelEventType.GoogleCustomEvent:
                this.fireEvent('event', event.data.action, {
                    event_category: event.data.category,
                    event_label: event.data.label,
                    value: event.data.value,
                });
                break;
            default:
                break;
        }
    };
    return GoogleAnalyticsGtag;
}());
exports.default = GoogleAnalyticsGtag;



//////////////////
// WEBPACK FOOTER
// ./~/@flowio/pixel/dist/gtag/googleAnalyticsGtag.js
// module id = 609
// module chunks = 0 1